
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
  },
}
